import { render, staticRenderFns } from "./ProfileMemberForm.vue?vue&type=template&id=a37e12b0&"
import script from "./ProfileMemberForm.vue?vue&type=script&lang=js&"
export * from "./ProfileMemberForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports